import { createContext } from 'react'

import { MysqlUsers } from '../graphqlTypes'

type MysqlUsersField = keyof MysqlUsers

type ReviewFilter = {
  categories: number[]
  column: MysqlUsersField
}

type UserAttributes = {
  categories: number[]
  columns: MysqlUsersField[]
}

type Context = {
  reviewFilters: ReviewFilter[]
  userAttributes: UserAttributes[]
}

const context: Context = {
  reviewFilters: [
    {
      categories: [2, 49],
      column: 'milk',
    },
    {
      categories: [8, 9, 12],
      column: 'youngest_child_weight',
    },
    {
      categories: [17],
      column: 'mother_birthday',
    },
    {
      categories: [22, 23],
      column: 'transport',
    },
    {
      categories: [24],
      column: 'mother_weight',
    },
  ],
  userAttributes: [
    {
      categories: [2, 4, 49],
      columns: ['support_member', 'milk'],
    },
    {
      categories: [8, 9, 10],
      columns: ['youngest_child_height', 'youngest_child_weight', 'support_member', 'noise_care'],
    },
    {
      categories: [12],
      columns: ['youngest_child_height', 'youngest_child_weight'],
    },
    {
      categories: [15, 68],
      columns: ['mother_height', 'mother_weight'],
    },
    {
      categories: [17, 59, 62, 75, 90, 91],
      columns: ['support_member'],
    },
    {
      categories: [22, 23],
      columns: [
        'building_type',
        'floor_plan',
        'prefecture_id',
        'residential_area',
        'transport',
        'step_existence',
        'youngest_child_height',
        'youngest_child_weight',
        'support_member',
      ],
    },
    {
      categories: [24, 69],
      columns: [
        'prefecture_id',
        'residential_area',
        'transport',
        'mother_height',
        'mother_weight',
        'youngest_child_height',
        'youngest_child_weight',
        'support_member',
      ],
    },
    {
      categories: [25],
      columns: [
        'prefecture_id',
        'residential_area',
        'transport',
        'youngest_child_height',
        'youngest_child_weight',
        'support_member',
      ],
    },
    {
      categories: [27, 30],
      columns: ['building_type', 'floor_plan', 'youngest_child_height', 'youngest_child_weight', 'support_member'],
    },
    {
      categories: [28],
      columns: ['building_type', 'floor_plan', 'support_member'],
    },
    {
      categories: [35],
      columns: ['prefecture_id', 'residential_area', 'building_type', 'floor_plan', 'noise_care'],
    },
    {
      categories: [41],
      columns: ['prefecture_id', 'residential_area', 'building_type'],
    },
    {
      categories: [66],
      columns: ['support_member', 'noise_care'],
    },
  ],
}

export default createContext(context)
